"use strict";

// =====================================================
// CUMPLE
//
// Archivo:
// src/fronend/reportes/cumple/cumple.js
// =====================================================

// =====================================================
// VARIABLES
// =====================================================

let registroscumple = [];

// =====================================================
// INICIALIZAR
// =====================================================

document.addEventListener(
"DOMContentLoaded",
() => {

    console.log(
        "REPORTE DE CUMPLEAÑOS INICIADO"
    );


    // =================================================
    // ELEMENTOS
    // =================================================

    const mesCumpleanos =
        document.getElementById(
            "mesCumpleanos"
        );


    const btnConsultarCumpleanos =
        document.getElementById(
            "btnConsultarCumpleanos"
        );


    const btnLimpiarCumpleanos =
        document.getElementById(
            "btnLimpiarCumpleanos"
        );


    const btnGenerarPDFCumpleanos =
        document.getElementById(
            "btnGenerarPDFCumpleanos"
        );


    // =================================================
    // VERIFICAR ELEMENTOS
    // =================================================

    console.log(
        "SELECT MES:",
        mesCumpleanos
    );


    console.log(
        "BOTÓN CONSULTAR:",
        btnConsultarCumpleanos
    );


    console.log(
        "BOTÓN LIMPIAR:",
        btnLimpiarCumpleanos
    );


    console.log(
        "BOTÓN PDF:",
        btnGenerarPDFCumpleanos
    );


    // =================================================
    // BOTÓN CONSULTAR
    // =================================================

    if (btnConsultarCumpleanos) {

        btnConsultarCumpleanos.addEventListener(
            "click",
            () => {

                consultarCumpleanos();

            }
        );

    }


    // =================================================
    // BOTÓN LIMPIAR
    // =================================================

    if (btnLimpiarCumpleanos) {

        btnLimpiarCumpleanos.addEventListener(
            "click",
            () => {

                limpiarCumpleanos();

            }
        );

    }


    // =================================================
    // BOTÓN PDF
    // =================================================

    if (btnGenerarPDFCumpleanos) {

        btnGenerarPDFCumpleanos.addEventListener(
            "click",
            () => {

                generarPDFCumpleanos();

            }
        );

    }

}


);

// =====================================================
// CONSULTAR CUMPLEAÑOS
// =====================================================

async function consultarCumpleanos() {


try {

    console.log(
        "INICIANDO CONSULTA DE CUMPLEAÑOS"
    );


    // =================================================
    // OBTENER MES
    // =================================================

    const mesCumpleanos =
        document.getElementById(
            "mesCumpleanos"
        );


    const mes =
        mesCumpleanos.value;


    console.log(
        "MES SELECCIONADO:",
        mes
    );


    // =================================================
    // VALIDAR MES
    // =================================================

    if (!mes) {

        alert(
            "Debe seleccionar un mes."
        );

        return;

    }


    // =================================================
    // URL
    // =================================================

    const url =
        `/reportes/cumple/listar?mes=${mes}`;


    console.log(
        "CONSULTANDO:",
        url
    );


    // =================================================
    // MOSTRAR CARGANDO
    // =================================================

    const tbody =
        document.getElementById(
            "tbodyCumpleanos"
        );


    tbody.innerHTML = `

        <tr>

            <td
                colspan="9"
                class="cargando">

                <i class="bi bi-hourglass-split"></i>

                Consultando cumpleaños...

            </td>

        </tr>

    `;


    // =================================================
    // FETCH
    // =================================================

    const respuesta =
        await fetch(url);


    console.log(
        "STATUS:",
        respuesta.status
    );


    // =================================================
    // VALIDAR RESPUESTA
    // =================================================

    if (!respuesta.ok) {

        const errorTexto =
            await respuesta.text();


        console.error(
            "ERROR DEL SERVIDOR:",
            errorTexto
        );


        throw new Error(
            `Error HTTP ${respuesta.status}`
        );

    }


    // =================================================
    // JSON
    // =================================================

    const datos =
        await respuesta.json();


    console.log(
        "DATOS RECIBIDOS:",
        datos
    );


    // =================================================
    // GUARDAR REGISTROS
    // =================================================

    registroscumple =
        Array.isArray(datos)
            ? datos
            : [];


    // =================================================
    // MOSTRAR RESULTADOS
    // =================================================

    mostrarCumpleanos();


} catch (error) {

    console.error(
        "ERROR AL CONSULTAR:",
        error
    );


    const tbody =
        document.getElementById(
            "tbodyCumpleanos"
        );


    tbody.innerHTML = `

        <tr>

            <td
                colspan="9"
                class="text-center text-danger py-5">

                <i
                    class="bi bi-exclamation-triangle"
                    style="font-size: 40px;">
                </i>

                <br>

                <strong>
                    Error al consultar el reporte
                </strong>

                <br>

                <small>
                    ${error.message}
                </small>

            </td>

        </tr>

    `;


    // =================================================
    // DESACTIVAR PDF
    // =================================================

    const btnPDF =
        document.getElementById(
            "btnGenerarPDFCumpleanos"
        );


    if (btnPDF) {

        btnPDF.disabled = true;

    }

}


}

// =====================================================
// MOSTRAR CUMPLEAÑOS
// =====================================================

function mostrarCumpleanos() {


const tbody =
    document.getElementById(
        "tbodyCumpleanos"
    );


const contador =
    document.getElementById(
        "contadorEmpleados"
    );


const textoMes =
    document.getElementById(
        "textoMesSeleccionado"
    );


const selectMes =
    document.getElementById(
        "mesCumpleanos"
    );


const btnPDF =
    document.getElementById(
        "btnGenerarPDFCumpleanos"
    );


// =================================================
// CONTADOR
// =================================================

contador.textContent =
    `${registroscumple.length} empleados`;


// =================================================
// NOMBRE MES
// =================================================

const opcion =
    selectMes.options[
        selectMes.selectedIndex
    ];


textoMes.textContent =
    `Cumpleaños correspondientes al mes de ${opcion.textContent.trim()}`;


// =================================================
// LIMPIAR TABLA
// =================================================

tbody.innerHTML = "";


// =================================================
// SIN DATOS
// =================================================

if (
    registroscumple.length === 0
) {

    tbody.innerHTML = `

        <tr>

            <td
                colspan="9"
                class="sin-resultados">

                <i class="bi bi-calendar-x"></i>

                <strong>
                    No se encontraron cumpleaños
                </strong>

                <br>

                No existen empleados registrados
                para el mes seleccionado.

            </td>

        </tr>

    `;


    // =================================================
    // DESACTIVAR PDF
    // =================================================

    if (btnPDF) {

        btnPDF.disabled = true;

    }


    return;

}


// =================================================
// ACTIVAR PDF
// =================================================

if (btnPDF) {

    btnPDF.disabled = false;

}


// =================================================
// RECORRER REGISTROS
// =================================================

registroscumple.forEach(
    (empleado) => {

        // =================================================
        // FECHA
        // =================================================

        const fecha =
            empleado[
                "FECHA DE NACIMIENTO"
            ];


        const fechaObj =
            new Date(fecha);


        // =================================================
        // FECHA FORMATEADA
        // =================================================

        let fechaFormateada = "";


        if (
            !isNaN(
                fechaObj.getTime()
            )
        ) {

            const dia =
                String(
                    fechaObj.getDate()
                ).padStart(
                    2,
                    "0"
                );


            const mes =
                String(
                    fechaObj.getMonth() + 1
                ).padStart(
                    2,
                    "0"
                );


            const anio =
                fechaObj.getFullYear();


            fechaFormateada =
                `${dia}/${mes}/${anio}`;

        }


        // =================================================
        // DÍA CUMPLEAÑOS
        // =================================================

        let diaCumpleanos = "";


        if (
            !isNaN(
                fechaObj.getTime()
            )
        ) {

            diaCumpleanos =
                String(
                    fechaObj.getDate()
                ).padStart(
                    2,
                    "0"
                );

        }


        // =================================================
        // CREAR FILA
        // =================================================

        const fila =
            document.createElement(
                "tr"
            );


        fila.innerHTML = `

            <td class="text-center">

                ${empleado.IDEMPLEADO ?? ""}

            </td>


            <td>

                <strong>

                    ${empleado.NOMBREEMPLEADO ?? ""}

                </strong>

            </td>


            <td>

                ${empleado.DPI ?? ""}

            </td>


            <td>

                ${fechaFormateada}

            </td>


            <td class="text-center">

                ${empleado.EDAD ?? ""}

            </td>


            <td class="text-center">

                <span
                    class="badge text-bg-success">

                    <i
                        class="bi bi-cake2-fill me-1">
                    </i>

                    ${diaCumpleanos}

                </span>

            </td>


            <td>

                ${empleado["NOMBRE DEL MES"] ?? ""}

            </td>


            <td>

                ${empleado.NOMBRETECNOLOGICO ?? ""}

            </td>


            <td>

                ${empleado.NOMBREPUESTO ?? ""}

            </td>

        `;


        tbody.appendChild(
            fila
        );

    }
);


}

// =====================================================
// LIMPIAR
// =====================================================

function limpiarCumpleanos() {


const selectMes =
    document.getElementById(
        "mesCumpleanos"
    );


const tbody =
    document.getElementById(
        "tbodyCumpleanos"
    );


const contador =
    document.getElementById(
        "contadorEmpleados"
    );


const textoMes =
    document.getElementById(
        "textoMesSeleccionado"
    );


const btnPDF =
    document.getElementById(
        "btnGenerarPDFCumpleanos"
    );


// =================================================
// LIMPIAR SELECT
// =================================================

selectMes.value = "";


// =================================================
// LIMPIAR DATOS
// =================================================

registroscumple = [];


// =================================================
// CONTADOR
// =================================================

contador.textContent =
    "0 empleados";


// =================================================
// TEXTO
// =================================================

textoMes.textContent =
    "Seleccione un mes para mostrar los resultados.";


// =================================================
// TABLA
// =================================================

tbody.innerHTML = `

    <tr>

        <td
            colspan="9"
            class="sin-resultados">

            <i class="bi bi-calendar-heart"></i>

            <strong>
                Consulte los cumpleaños
            </strong>

            <br>

            Seleccione un mes para
            mostrar los empleados
            cumpleañeros.

        </td>

    </tr>

`;


// =================================================
// DESACTIVAR PDF
// =================================================

if (btnPDF) {

    btnPDF.disabled = true;

}


}

// =====================================================
// GENERAR PDF
//
// Utiliza exactamente los datos contenidos en:
// registroscumple
//
// No realiza una nueva consulta SQL.
// =====================================================

function generarPDFCumpleanos() {


try {

    console.log(
        "INICIANDO GENERACIÓN DEL PDF"
    );


    // =================================================
    // VALIDAR REGISTROS
    // =================================================

    if (
        !Array.isArray(
            registroscumple
        ) ||
        registroscumple.length === 0
    ) {

        alert(
            "Primero debe consultar un mes con empleados."
        );

        return;

    }


    // =================================================
    // VALIDAR JSPDF
    // =================================================

    if (
        !window.jspdf ||
        !window.jspdf.jsPDF
    ) {

        console.error(
            "jsPDF no está disponible."
        );


        alert(
            "No se pudo cargar la librería para generar el PDF."
        );


        return;

    }


    // =================================================
    // CREAR DOCUMENTO
    // =================================================

    const {
        jsPDF
    } = window.jspdf;


    const documento =
        new jsPDF({

            orientation:
                "landscape",

            unit:
                "mm",

            format:
                "a4"

        });


    // =================================================
    // OBTENER MES
    // =================================================

    const selectMes =
        document.getElementById(
            "mesCumpleanos"
        );


    const opcion =
        selectMes.options[
            selectMes.selectedIndex
        ];


    const nombreMes =
        opcion
            ? opcion.textContent.trim()
            : "MES";


    // =================================================
    // FECHA DE GENERACIÓN
    // =================================================

    const fechaActual =
        new Date();


    const diaActual =
        String(
            fechaActual.getDate()
        ).padStart(
            2,
            "0"
        );


    const mesActual =
        String(
            fechaActual.getMonth() + 1
        ).padStart(
            2,
            "0"
        );


    const anioActual =
        fechaActual.getFullYear();


    const fechaGeneracion =
        `${diaActual}/${mesActual}/${anioActual}`;


    // =================================================
    // ENCABEZADO
    // =================================================

    documento.setFont(
        "helvetica",
        "bold"
    );


    documento.setFontSize(
        18
    );


    documento.text(
        "CONSULTING S.A.",
        148,
        15,
        {
            align:
                "center"
        }
    );


    documento.setFontSize(
        13
    );


    documento.text(
        "REPORTE DE CUMPLEAÑOS DE EMPLEADOS",
        148,
        23,
        {
            align:
                "center"
        }
    );


    documento.setFont(
        "helvetica",
        "normal"
    );


    documento.setFontSize(
        10
    );


    documento.text(
        `Mes consultado: ${nombreMes}`,
        14,
        32
    );


    documento.text(
        `Fecha de generación: ${fechaGeneracion}`,
        283,
        32,
        {
            align:
                "right"
        }
    );


    documento.text(
        `Total de empleados: ${registroscumple.length}`,
        14,
        39
    );


    // =================================================
    // PREPARAR TODAS LAS FILAS
    // =================================================

    const filas =
        registroscumple.map(
            (empleado) => {

                // =====================================
                // FECHA
                // =====================================

                const fecha =
                    empleado[
                        "FECHA DE NACIMIENTO"
                    ];


                const fechaObj =
                    new Date(fecha);


                let fechaFormateada =
                    "";


                let diaCumpleanos =
                    "";


                if (
                    !isNaN(
                        fechaObj.getTime()
                    )
                ) {

                    const dia =
                        String(
                            fechaObj.getDate()
                        ).padStart(
                            2,
                            "0"
                        );


                    const mes =
                        String(
                            fechaObj.getMonth() + 1
                        ).padStart(
                            2,
                            "0"
                        );


                    const anio =
                        fechaObj.getFullYear();


                    fechaFormateada =
                        `${dia}/${mes}/${anio}`;


                    diaCumpleanos =
                        dia;

                }


                // =====================================
                // DEVOLVER LAS 9 COLUMNAS
                // =====================================

                return [

                    empleado.IDEMPLEADO ?? "",

                    empleado.NOMBREEMPLEADO ?? "",

                    empleado.DPI ?? "",

                    fechaFormateada,

                    empleado.EDAD ?? "",

                    diaCumpleanos,

                    empleado[
                        "NOMBRE DEL MES"
                    ] ?? "",

                    empleado.NOMBRETECNOLOGICO ?? "",

                    empleado.NOMBREPUESTO ?? ""

                ];

            }
        );


    // =================================================
    // GENERAR TABLA PDF
    // =================================================

    documento.autoTable({

        startY:
            45,


        head: [[

            "ID",

            "Empleado",

            "DPI",

            "Fecha nacimiento",

            "Edad",

            "Día cumpleaños",

            "Mes",

            "Departamento",

            "Puesto"

        ]],


        body:
            filas,


        theme:
            "grid",


        styles: {

            font:
                "helvetica",

            fontSize:
                7,

            cellPadding:
                2,

            valign:
                "middle"

        },


        headStyles: {

            fontStyle:
                "bold",

            halign:
                "center"

        },


        bodyStyles: {

            valign:
                "middle"

        },


        columnStyles: {

            0: {

                halign:
                    "center",

                cellWidth:
                    12

            },


            1: {

                cellWidth:
                    38

            },


            2: {

                cellWidth:
                    30

            },


            3: {

                halign:
                    "center",

                cellWidth:
                    27

            },


            4: {

                halign:
                    "center",

                cellWidth:
                    12

            },


            5: {

                halign:
                    "center",

                cellWidth:
                    20

            },


            6: {

                cellWidth:
                    25

            },


            7: {

                cellWidth:
                    38

            },


            8: {

                cellWidth:
                    38

            }

        },


        margin: {

            left:
                10,

            right:
                10

        },


        didDrawPage:
            function () {

                // =====================================
                // PIE DE PÁGINA
                // =====================================

                const pagina =
                    documento.internal.getNumberOfPages();


                documento.setFont(
                    "helvetica",
                    "normal"
                );


                documento.setFontSize(
                    8
                );


                documento.text(
                    "Consulting S.A. - Sistema de Nóminas",
                    148,
                    202,
                    {
                        align:
                            "center"
                    }
                );


                documento.text(
                    `Página ${pagina}`,
                    283,
                    202,
                    {
                        align:
                            "right"
                    }
                );

            }

    });


    // =================================================
    // NOMBRE DEL ARCHIVO
    // =================================================

    const nombreArchivo =
        `Reporte_Cumpleanos_${nombreMes}.pdf`;


    // =================================================
    // GENERAR PDF
    // =================================================

    documento.save(
        nombreArchivo
    );


    console.log(
        "PDF GENERADO CORRECTAMENTE:",
        nombreArchivo
    );


} catch (error) {

    console.error(
        "ERROR AL GENERAR PDF:",
        error
    );


    alert(
        "No fue posible generar el PDF."
    );

}


}
